/* eslint-disable no-nested-ternary */
import {omit} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import type {MinipurchaseResponseBody, UpdateMinipurchaseRequestBody} from '@dms/api/finance';

import type {ExternalFilter} from '../types/ExternalFilter';
import {buildTestDriveSlot} from './buildTestDriveSlot';
import {toTestDriveSlotRequestBody} from './toTestDriveSlotRequestBody';
import {transformExternalFilterToMinipurchaseSpecification} from './transformExternalFilterToMinipurchaseSpecification';

export function buildMinipurchaseUpdateBody(
  baseMiniPurchase: MinipurchaseResponseBody,
  values: ExternalFilter,
  tenantCurrency: string
): UpdateMinipurchaseRequestBody {
  return {
    // testDriveRequestedDate is response-only; the slot travels in testDriveScheduledAt.
    ...omit(['testDriveRequestedDate'], baseMiniPurchase),
    minipurchaseId: baseMiniPurchase.id,
    filteredSpecifications:
      'type' in values
        ? transformExternalFilterToMinipurchaseSpecification(values)
        : baseMiniPurchase.filteredSpecifications,
    additionalInformation:
      'additionalInformation' in values
        ? (values.additionalInformation ?? null)
        : baseMiniPurchase.additionalInformation,
    testDriveRequested:
      'testDriveRequested' in values
        ? values.testDriveRequested?.[0] === 'yes'
        : baseMiniPurchase.testDriveRequested,
    testDriveScheduledAt:
      'testDriveScheduledAtDate' in values
        ? buildTestDriveSlot(values.testDriveScheduledAtDate, values.testDriveScheduledAtTime)
        : toTestDriveSlotRequestBody(baseMiniPurchase),
    testDriveNote:
      'testDriveNote' in values ? values.testDriveNote : baseMiniPurchase.testDriveNote,
    preferredDownPayment:
      'preferredDownPayment' in values
        ? isNotNilOrEmpty(values.preferredDownPayment)
          ? {amount: String(values.preferredDownPayment), currency: tenantCurrency}
          : null
        : baseMiniPurchase.preferredDownPayment,
    paymentPreferenceCodeId:
      'paymentPreferenceCodeId' in values
        ? (values.paymentPreferenceCodeId?.[0] ?? null)
        : baseMiniPurchase.paymentPreferenceCodeId,
  };
}
